export default __webpack_public_path__ + "static/media/card-add-to-cart-icon.58a8e053.svg";